import { MDSBadge, MDSIcon, MDSIconKind, MDSText, MDSToggle } from "@/mds";
import { ThemeType, useTheme } from "@/mds/themes/theme-context";
import styled from "@emotion/styled";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { MenuItem } from "react-aria-components";
import { useCallback } from "react";
import { GatedFeature } from "@/store/feature-gates/types";
import { PaywallContext } from "@/domains/metrics";

export const SidebarDropdownThemeSwitcher = observer(function SidebarDropdownThemeSwitcher() {
  const { themeType, toggleTheme } = useTheme();
  const { store } = useAppStore();
  const isPaid = store.subscriptions.personalSubscription?.isPaid ?? false;

  const handleToggleTheme = useCallback(() => {
    const isPaid = store.subscriptions.personalSubscription?.isPaid ?? false;
    const goingDark = themeType !== ThemeType.HarvestMoon;
    if (goingDark && !isPaid) {
      store.subscriptions.openUsageLimitUpsell({
        feature: GatedFeature.DarkMode,
        context: PaywallContext.DarkModeToggle,
      });
      return;
    }
    toggleTheme();
  }, [store.subscriptions, themeType, toggleTheme]);

  return (
    <StyledContainer onClick={handleToggleTheme}>
      <StyledLeftContainer>
        <MDSIcon kind={MDSIconKind.Moon} size={11} />
        <MDSText>Dark mode</MDSText> {!isPaid && <MDSBadge label="Pro" />}
      </StyledLeftContainer>
      <MDSToggle checked={themeType === ThemeType.HarvestMoon} onChange={handleToggleTheme} />
    </StyledContainer>
  );
});

export const StyledContainer = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  cursor: pointer;

  &[data-focused] {
    background-color: ${({ theme }) => theme.colors.background.menu.hover};
  }

  &[data-selected] {
    background-color: ${({ theme }) => theme.colors.background.menu.selected};
  }

  &[data-disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.menu.hover};
  }
`;

const StyledLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
`;
